export default "__VITE_PUBLIC_ASSET__341bb1e4__"